$shm_hitalama_map_widget_float_customizer $shm_hitalama_map_widget_float
	controls /
		<= Controls $mol_list
			sub /
				<= Head $mol_view
					sub /
						<= Deck_switch
						<= Name $mol_string
							value? <=> title? \
						<= Visible $mol_check_box
							title \Отображать в меню
							checked? <=> visible_in_menu? false
							- value? <=> title? \
						- <= Base $mol_select
							value? <=> base_type? \$mol_view
						<= Create $mol_button_major
							title \Создать
							click? <=> create_instance? null
				<= Fqn_row $mol_view
					sub /
						<= Fqn $mol_string
							hint \FQN компонента
							value? <=> fqn? \
						<= Rename $mol_button_minor
							title \Переименовать
							enabled <= rename_enabled false
							click? <=> rename? null
				<= Definition_link $shm_button_copy
					title \Копировать ссылку на определение
					text <= definition_link \
				<= Deck_content
	Deck $mol_deck
		Switch => Deck_switch
		Content => Deck_content
		current? <=> soure_type_current? \0
		items /
			<= View_tree $shm_textarea_code
				title \View
				sidebar_showed true
				value? <=> code_view_tree? \
			<= Css $shm_textarea_code
				title <= style_title \CSS
				sidebar_showed true
				value? <=> code_css? \
			<= Js $shm_textarea_code
				title <= logic_title \TS
				sidebar_showed true
				value? <=> code_js? \
			<= Dependencies $shm_textarea_code
				title \Зависимости
				hint \FQN ссылка-на-определение — по одной на строку
				value? <=> dependencies_text? \
	attr *
		^
		mol_theme \$mol_theme_special
